// Module
var code = "<!-- ko if: _avalableForScreen --> <a class=\"text-sm sps-btn sps-btn-outline btn-color-invoicing btn-invoicing\" data-bind=\"tooltip: {content: Name}, click: ConvertToInvoice, style: _style\"> <i class=\"fa fa-book\" aria-hidden=\"true\"></i> <span><!-- ko text: Name--><!-- /ko --></span> </a> <!-- /ko -->";
// Exports
export default code;